export type TranslationType = {
    key : string;
    fallback ?: string;
};

export type LinkType = {
    label : {
        translation : TranslationType;
    };
    path : string;
};

export type LinkCollectionType = LinkType[];

export type MenuSectionType = {
    id : number;
    name : {
        translation : TranslationType;
    };
    path : string;
    items : SectionItemTypeCollection;
};

export type MenuSectionCollection = MenuSectionType[];

export type SectionItemType = {
    title ?: {
        translation : TranslationType;
    };
    icon ?: string;
    links : LinkCollectionType;
};

export type SectionItemTypeCollection = SectionItemType[];

const menuDefaults : MenuSectionCollection = [
    {
        id: 2,
        name: { translation: { key: 'why_bubo', fallback: 'Proč BUBO' } },
        path: '/jak-to-funguje',
        items: [
            {
                title: { translation: { key: 'how_it_works_m', fallback: 'Nejčastější dotazy' } },
                icon: 'HelpOutlineRounded',
                links: [
                    /* {
                        label: { translation: { key: 'how_it_works', fallback: 'Jak to funguje?' } },
                        path: '/jak-to-funguje',
                    }, */
                    {
                        label: { translation: { key: 'where_to_find_prices', fallback: 'Kde zjistit ceny?' } },
                        path: '/kde-zjistit-ceny',
                    },
                    {
                        label: { translation: { key: 'what_we_transport', fallback: 'Co přepravujeme?' } },
                        path: '/co-prepravujeme',
                    },
                    {
                        label: { translation: { key: 'where_we_transport', fallback: 'Kam přepravujeme?' } },
                        path: '/kam-prepravujeme',
                    },
                ],
            },
            {
                title: { translation: { key: 'about_us', fallback: 'O nás' } },
                icon: 'InfoOutlined',
                links: [
                    {
                        label: { translation: { key: 'who_are_we', fallback: 'Kdo jsme?' } },
                        path: '/o-nas',
                    },
                    {
                        label: { translation: { key: 'case_studies', fallback: 'Případové studie' } },
                        path: '/pripadove-studie',
                    },
                    /* {
                        label: { translation: { key: 'our_references', fallback: 'Naše reference' } },
                        path: '/nase-reference',
                    }, */
                ],
            },
            /* {
                title: { translation: { key: 'references', fallback: 'Aktuality' } },
                links: [
                    {
                        label: { translation: { key: 'articles', fallback: 'Články' } },
                        path: '/clanky',
                    },
                    {
                        label: { translation: { key: 'blog', fallback: 'Blog' } },
                        path: '/blog',
                    },
                    {
                        label: { translation: { key: 'news', fallback: 'Novinky' } },
                        path: '/novinky',
                    },
                ],
            }, */
        ],
    },
    {
        id: 3,
        name: { translation: { key: 'services', fallback: 'Služby' } },
        path: '/sluzby/nejurgentnejsi-dodani',
        items: [
            {
                title: { translation: { key: 'services', fallback: 'Služby' } },
                icon: 'LocalShippingOutlined',
                links: [
                    {
                        label: { translation: { key: 'same_day_delivery', fallback: 'Nejurgentnější dodání' } },
                        path: '/sluzby/nejurgentnejsi-dodani',
                    },
                    {
                        label: { translation: { key: 'road_transport', fallback: 'Silniční přeprava' } },
                        path: '/sluzby/silnicni-preprava',
                    },
                    {
                        label: { translation: { key: 'air_express_courier', fallback: 'Letecký express - kurýr' } },
                        path: '/sluzby/expresni-letecka-preprava',
                    },
                    {
                        label: { translation: { key: 'air_cargo', fallback: 'Letecké cargo' } },
                        path: '/sluzby/letecke-cargo',
                    },
                    {
                        label: { translation: { key: 'rail_transport', fallback: 'Železniční přeprava' } },
                        path: '/sluzby/zeleznicni-preprava',
                    },
                    /* {
                        label: { translation: { key: 'naval_transport', fallback: 'Námořní přeprava' } },
                        path: '/namorni-preprava',
                    }, */
                ],
            },
            {
                title: { translation: { key: 'additional_services', fallback: 'Doplňkové služby' } },
                icon: 'AddCircleOutlineRounded',
                links: [
                    {
                        label: { translation: { key: 'customs_services', fallback: 'Celní služby' } },
                        path: '/sluzby/doplnkove-sluzby',
                    },
                    {
                        label: { translation: { key: 'storage', fallback: 'Skladování' } },
                        path: '/sluzby/doplnkove-sluzby',
                    },
                    {
                        label: { translation: { key: 'insurance-2', fallback: 'Pojištění' } },
                        path: '/sluzby/doplnkove-sluzby',
                    },
                ],
            },
            {
                title: { translation: { key: 'online', fallback: 'Online řešení' } },
                icon: 'ComputerRounded',
                links: [
                    {
                        label: { translation: { key: 'demand_form', fallback: 'Poptávkový formulář' } },
                        path: '/poptavka',
                    },
                    {
                        label: { translation: { key: 'app_bubo', fallback: 'Systém myBUBO' } },
                        path: '/aplikace-mybubo',
                    },
                ],
            },
        ],
    },
    {
        id: 4,
        name: { translation: { key: 'transport_guide', fallback: 'Přepravní průvodce' } },
        path: '/prepravni-pruvodce/baleni-dokumentu',
        items: [
            {
                title: { translation: { key: 'guide', fallback: 'Průvodce' } },
                icon: 'ExploreOutlined',
                links: [
                    {
                        label: { translation: { key: 'packaging', fallback: 'Balení zásilek' } },
                        path: '/prepravni-pruvodce/baleni-dokumentu',
                    },
                    {
                        label: { translation: { key: 'transportation_progress', fallback: 'Průběh přepravy' } },
                        path: '/prepravni-pruvodce/prubeh-prepravy',
                    },
                    {
                        label: { translation: { key: 'carriers_and_services', fallback: 'Výběr služby' } },
                        path: '/prepravni-pruvodce/vyber-sluzby',
                    },
                    {
                        label: { translation: { key: 'customs_procedure', fallback: 'Celní řízení' } },
                        path: '/prepravni-pruvodce/celni-rizeni',
                    },
                    {
                        label: { translation: { key: 'insurance', fallback: 'Pojištění' } },
                        path: '/prepravni-pruvodce/pojisteni',
                    },
                    {
                        label: { translation: { key: 'payment_and_returns', fallback: 'Platba a reklamace' } },
                        path: '/prepravni-pruvodce/platba-a-reklamace',
                    },
                ],
            },
            {
                title: { translation: { key: 'useful', fallback: 'Užitečné' } },
                icon: 'StarsOutlined',
                links: [
                    {
                        label: { translation: { key: 'incoterms', fallback: 'Dodací pomínky - incoterms' } },
                        path: '/dodaci-podminky',
                    },
                    {
                        label: { translation: { key: 'packaging_material', fallback: 'Obalový materiál' } },
                        path: '/obalovy-material',
                    },
                    {
                        label: { translation: { key: 'glossary_of_transport_terms', fallback: 'Slovníček přepravních pojmů' } },
                        path: '/slovnik-prepravnich-pojmu',
                    },
                    {
                        label: { translation: { key: 'fuel_surcharge', fallback: 'Palivové příplatky dopravců' } },
                        path: '/palivovy-priplatek',
                    },
                    {
                        label: { translation: { key: 'dokumenty-ke-stazeni', fallback: 'Dokumenty ke stažení' } },
                        path: '/dokumenty-ke-stazeni',
                    },
                ],
            },
        ],
    },
    {
        id: 5,
        name: { translation: { key: 'contact', fallback: 'Kontakty' } },
        path: '/kontakt',
        items: [],
    },
    {
        id: 6,
        name: { translation: { key: 'articles', fallback: 'Články' } },
        path: '/clanky-a-zajimavosti',
        items: [],
    },
];

export default menuDefaults;
